import { render } from "./ProbeCalibrationCreate.vue?vue&type=template&id=b1b4a3b8"
import script from "./ProbeCalibrationCreate.vue?vue&type=script&lang=js"
export * from "./ProbeCalibrationCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__